/**
 * Ory APIs
 *
 * Contact: support@ory.sh
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { OAuth2LoginRequest } from './oAuth2LoginRequest';
import { UiContainer } from './uiContainer';


export interface RegistrationFlow { 
    /**
     * Active, if set, contains the registration method that is being used. It is initially not set. password CredentialsTypePassword oidc CredentialsTypeOIDC totp CredentialsTypeTOTP lookup_secret CredentialsTypeLookup webauthn CredentialsTypeWebAuthn code CredentialsTypeCodeAuth passkey CredentialsTypePasskey profile CredentialsTypeProfile link_recovery CredentialsTypeRecoveryLink  CredentialsTypeRecoveryLink is a special credential type linked to the link strategy (recovery flow).  It is not used within the credentials object itself. code_recovery CredentialsTypeRecoveryCode
     */
    active?: RegistrationFlow.ActiveEnum;
    /**
     * ExpiresAt is the time (UTC) when the flow expires. If the user still wishes to log in, a new flow has to be initiated.
     */
    expires_at: string;
    /**
     * ID represents the flow\'s unique ID. When performing the registration flow, this represents the id in the registration ui\'s query parameter: http://<selfservice.flows.registration.ui_url>/?flow=<id>
     */
    id: string;
    /**
     * IssuedAt is the time (UTC) when the flow occurred.
     */
    issued_at: string;
    /**
     * Ory OAuth 2.0 Login Challenge.  This value is set using the `login_challenge` query parameter of the registration and login endpoints. If set will cooperate with Ory OAuth2 and OpenID to act as an OAuth2 server / OpenID Provider.
     */
    oauth2_login_challenge?: string;
    oauth2_login_request?: OAuth2LoginRequest;
    organization_id?: string | null;
    /**
     * RequestURL is the initial URL that was requested from Ory Kratos. It can be used to forward information contained in the URL\'s path or query for example.
     */
    request_url: string;
    /**
     * ReturnTo contains the requested return_to URL.
     */
    return_to?: string;
    /**
     * SessionTokenExchangeCode holds the secret code that the client can use to retrieve a session token after the flow has been completed. This is only set if the client has requested a session token exchange code, and if the flow is of type \"api\", and only on creating the flow.
     */
    session_token_exchange_code?: string;
    /**
     * State represents the state of this request:  choose_method: ask the user to choose a method (e.g. registration with email) sent_email: the email has been sent to the user passed_challenge: the request was successful and the registration challenge was passed.
     */
    state: any | null;
    /**
     * TransientPayload is used to pass data from the registration to a webhook
     */
    transient_payload?: object;
    /**
     * The flow type can either be `api` or `browser`.
     */
    type: string;
    ui: UiContainer;
}
export namespace RegistrationFlow {
    export type ActiveEnum = 'password' | 'oidc' | 'totp' | 'lookup_secret' | 'webauthn' | 'code' | 'passkey' | 'profile' | 'link_recovery' | 'code_recovery';
    export const ActiveEnum = {
        Password: 'password' as ActiveEnum,
        Oidc: 'oidc' as ActiveEnum,
        Totp: 'totp' as ActiveEnum,
        LookupSecret: 'lookup_secret' as ActiveEnum,
        Webauthn: 'webauthn' as ActiveEnum,
        Code: 'code' as ActiveEnum,
        Passkey: 'passkey' as ActiveEnum,
        Profile: 'profile' as ActiveEnum,
        LinkRecovery: 'link_recovery' as ActiveEnum,
        CodeRecovery: 'code_recovery' as ActiveEnum
    };
}


